// Sign-up attribution helpers.
//
// Nate's email campaigns point at two dedicated sign-up links:
//   /signup/trainer  -> "Sign up as a Trainer"
//   /signup/trainee  -> "Sign up as a Trainee"
// while /signup stays the generic, nothing-preselected form. Reporting needs to
// tell those apart, so the SignupCompleted event carries a `signupEntry` field
// describing which link the visitor arrived through.

export const SIGNUP_ENTRY_GENERIC = 'generic';

/**
 * Build the `signupEntry` value for the SignupCompleted analytics event.
 *
 * @param {string?} userType user type preselected by the sign-up URL, or null
 *   when the visitor came in through the generic /signup link.
 * @returns {string} e.g. 'trainer_link', 'trainee_link' or 'generic'.
 */
export const signupEntryForUserType = userType =>
  userType ? `${userType}_link` : SIGNUP_ENTRY_GENERIC;

// Standard UTM parameters that campaign tools (e.g. Mailchimp) append to a link.
export const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

/**
 * Pick the standard UTM parameters out of a URL query string, so a campaign's
 * performance can be measured separately from the plain link.
 *
 * @param {string?} search query string, with or without the leading '?'.
 * @returns {Object} object with only the UTM keys that were present and non-empty.
 */
export const pickUtmParams = search => {
  if (!search || typeof URLSearchParams === 'undefined') {
    return {};
  }
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return UTM_PARAM_KEYS.reduce((picked, key) => {
    const value = params.get(key);
    return value ? { ...picked, [key]: value } : picked;
  }, {});
};
